import TableC from "@/CommonElements/TableC";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SelectCountry } from "@/Component/Form/SelectCountry";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { Tag } from "antd";
import { SearchFilter } from "@/CommonElements/SearchFilter/SearchFilter";
import { ActionsFooter } from "@/Component/ActionsFooter";
import { useViewPilgrims } from "./ReceptionCenter/hooks/useViewPilgrims";

export const ManifestPilgrimsModal = ({ show, onClose, arrival }) => {
    const [{ count, ...filters }, setFilters] = useState({ count: 0 });
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const { t } = useTranslation();
    const { getLocalizedText } = useLocalizedText();
    const manifestId = arrival?.manifest_id || arrival?.tdm_id;

    // ============================================
    // Side Effects
    // ============================================
    const { pilgrims, meta, loading } = useViewPilgrims({ filters, page, pageSize, manifestId });

    // ============================================
    // Handlers
    // ============================================
    const handleDebouncedChange = (value) => {
        setFilters(value);
        setPage(1);
    };

    const columns = [
        {
            name: t("FULL_NAME"),
            key: "full_name_ar",
            render: (value, row) => getLocalizedText(value, row.full_name_en) || "-",
        },
        {
            name: t("NATIONALITY"),
            key: "current_nationality_id",
            render: (value) => <SelectCountry.Display value={value} />
        },
        {
            name: t("HAJJ_ID"),
            key: "applicant_id",
            render: (value) => value || "-",
        },
        {
            name: t("PASSPORT_NUMBER"),
            key: "passport_number",
            render: (value) => value || "-",
        },
        {
            name: t("ACCOMMODATION_STATUS"),
            key: "is_accommodated",
            render: (value) => <Tag color={value ? "green" : "red"}>{value ? t("ACCOMMODATED") : t("NOT_ACCOMMODATED")}</Tag>,
        },
    ];

    return (
        <Modal show={show} onHide={onClose}
            centered size="lg"
            scrollable
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>
                    {t("MANIFEST_PILGRIMS")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pb-0">
                <SearchFilter
                    onChange={handleDebouncedChange}
                    debounced
                />
                <TableC
                    columnsFilter={false}
                    columns={columns}
                    data={pilgrims}
                    loading={loading}
                    pagination={{
                        pageSize: pageSize,
                        current: page,
                        total: meta?.total || 0,
                        onChange: (page) => {
                            setPage(page);
                        }
                    }}
                />
            </Modal.Body>
            
            <ActionsFooter className="px-3">
                <Button onClick={onClose} className="btn btn-danger btn-sm">
                    {t("CLOSE")}
                </Button>
            </ActionsFooter>
        </Modal>
    );
};